<template>
    <div>
        <div class="bg-silver mt-0 mt-md-1">
            <div class="block-filter">
                <div class="col-12 select-mobile-options">
                    <form @submit.prevent="validateForm" ref="form">
                        <div class="row">
                            <div class="col-12 ">
                                <input type="file" style="width: 100%" ref="fileInput"  name="files[]" multiple/>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col-12 ">
                                <button class="btn btn-red m-0" id="search" type="submit">
                                    Bestanden uploaden
                                    <i class="avia-icons-arrow-left"></i>
                                </button>
                            </div>

                        </div>

                    </form>

                </div>
            </div>
        </div>

        <div v-if="postSuccessful !== null" class="messages-container pt-5">

            <div v-if="! messages.length && ! postSuccessful">
                <div class="alert alert-danger">
                    Er is een onbekende fout opgetreden
                </div>
            </div>

            <div v-for="message in messages"
                 :class='{"alert": true, "alert-success": postSuccessful, "alert-warning": ! postSuccessful}'>
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data() {
            return {
                messages: [],
                postSuccessful: null
            };
        },
        methods: {
            handleFileChange(event) {
                this.selectedFile = event.target.files[0];
            },
            validateForm(e) {
                let formData = new FormData(e.target)
                axios.post(route('admin.api.imported-files.upload'), formData)
                    .then((response) => {
                        this.messages = response.data.messages || [];
                        this.postSuccessful = response.data.success || false
                    })
                    .catch((response) => {
                        console.log(response);
                        this.messages = []
                        this.postSuccessful = false
                    })
                    .then(() => this.$nextTick(() => {
                        this.isLoading = false

                        if (!this.isLoaded) {
                            this.isLoaded = true
                        }
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }))
            }
        }
    };
</script>
